import Icon from '@expo/vector-icons';
export default Icon;
